import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { OptionsNgxOwCarouselService } from 'dmmp-services'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-banner-grid',
  templateUrl: './banner-grid.component.html'
})
export class BannerGridComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor(
    public localDeviceDetector: LocalDeviceDetectorService
  ) { }

  ngOnInit(): void {
  }

}
